
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7He8T", function(module, exports) {

$parcel$export(module.exports, "HomepageIcon", () => $7d9faceb3b8be7cd$export$eb28ea972995380e);
/* HomepageIcon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fJM5Q = parcelRequire("fJM5Q");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7d9faceb3b8be7cd$var$HomepageContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1e0c1o8l _s7n4nkob _2hwx14y2",
            __cmplp.className
        ])
    });
});
const $7d9faceb3b8be7cd$export$eb28ea972995380e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($7d9faceb3b8be7cd$var$HomepageContainer, {
        "data-testid": "space-homepage"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fJM5Q))), {
        label: ""
    }));

});


//# sourceMappingURL=HomepageIcon.a5e80060.js.map
